import { Action, createReducer, on } from '@ngrx/store';
import { WebsiteModel } from '../../../../components/user-dashboard/portal/portal.model';

import {
  NotificationsActions,
  newNotifications,
  setNotificationAsReadSuccess,
} from './notifications.actions';

import { SessionActions } from '../user/auth/auth.actions';
import {
  NotificationElement,
  NotificationStatusEnum,
} from 'src/app/models/dashboard.shared';

export interface NotificationsState {
  notifications: NotificationElement[];
  unreadNotificationsCount: number;
  unreadSalesCount: number;
  unreadCommentsCount: number;
  unreadAffiliatesCount: number;
  unreadSystemCount: number;
  loaded: boolean;
  error: any;
}

const initialState: NotificationsState = {
  notifications: [],
  unreadNotificationsCount: null,
  unreadSalesCount: 0,
  unreadCommentsCount: 0,
  unreadAffiliatesCount: 0,
  unreadSystemCount: 0,
  loaded: false,
  error: null,
};

export const notificationsReducer = createReducer(
  initialState,
  on(NotificationsActions.load, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(
    NotificationsActions.loadSuccess,
    (
      state,
      {
        notifications,
        unreadNotificationsCount,
        unreadSalesCount,
        unreadCommentsCount,
        unreadAffiliatesCount,
        unreadSystemCount,
      }
    ) => ({
      ...state,
      notifications: notifications,
      unreadNotificationsCount: unreadNotificationsCount,
      unreadSalesCount,
      unreadCommentsCount,
      unreadAffiliatesCount,
      unreadSystemCount,
      loaded: true,
    })
  ),

  on(NotificationsActions.loadFailure, (state, { error }) => ({
    ...state,
    error,
    loaded: false,
  })),

  on(newNotifications, (state, { notification }) => {
    // Prevent duplicates
    if (state.notifications.some((n) => n.id === notification.id)) {
      return state;
    }
    const updatedObject = [notification, ...state.notifications];
    return {
      ...state,
      notifications: updatedObject,
      unreadNotificationsCount: state.unreadNotificationsCount + 1,
      loaded: true,
    };
  }),

  on(setNotificationAsReadSuccess, (state, { notificationsIds }) => {
    let notifications: NotificationElement[] = JSON.parse(
      JSON.stringify(state.notifications)
    );
    const oldNotification = notifications.find(
      (n) => n.id === notificationsIds[0]
    );

    if (oldNotification.status == NotificationStatusEnum.read) {
      return state;
    }

    const updatedNotifications = notifications.map((notification) => {
      if (notificationsIds.includes(notification.id)) {
        return { ...notification, status: NotificationStatusEnum.read };
      }
      return notification;
    });

    return {
      ...state,
      notifications: updatedNotifications,
      unreadNotificationsCount: state.unreadNotificationsCount - 1,
      loaded: true,
    };
  }),
  on(NotificationsActions.loadMoreSuccess, (state, { notifications }) => ({
    ...state,
    notifications: [...state.notifications, ...notifications],
    loaded: true,
  })),
  on(SessionActions.forget, (state) => initialState)
);
